import { useEffect } from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  useMediaQuery,
  Backdrop,
  CircularProgress,
} from '@mui/material';

import GoBack from '@assets/global/goback.svg';
import MenuIcon from '@mui/icons-material/Menu';

import { Outlet, useLocation, useNavigate } from 'react-router';
import { LanguageMenu } from '@/components/atoms';
import { useAuth } from '@/contexts/auth';
import DrawerMenu from './components/drawer';
import { usePageTitle } from '@/contexts/pagetitle';
import AvatarMenu from './components/avatarmenu';
import { useMenuContext } from '@/contexts/menu';

const drawerWidth = 240;

export default function MasterLayout() {
  const isMobile = useMediaQuery('(max-width:600px)');
  // const [open, setOpen] = useState(!isMobile);
  const { title } = usePageTitle();
  const { openMenu, setOpenMenu } = useMenuContext();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Redirecionamento seguro
  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        navigate('/auth/login');
      } else if (location.pathname === '/') {
        navigate('/modules');
      }
    }
  }, [isLoading, isAuthenticated]);

  // Tela de loading
  if (isLoading) {
    return (
      <Box bgcolor="#E1E7EE" width="100vw" height="100vh">
        <Backdrop
          sx={{
            bgcolor: '#E1E7EE',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open
        >
          <CircularProgress color="primary" />
        </Backdrop>
      </Box>
    );
  }

  const toggleDrawer = () => {
    if (setOpenMenu) {
      setOpenMenu(!openMenu);
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#C5CCDC' }}>
      <AppBar
        position="fixed"
        sx={{
          width: {
            sm: `calc(100% - ${openMenu && !isMobile ? drawerWidth : 0}px)`,
          },
          ml: { sm: `${openMenu && !isMobile ? drawerWidth : 0}px` },
          backgroundColor: '#C5CCDC',
          color: '#333',
          transition: 'width 0.3s, margin 0.3s',
        }}
        elevation={0}
      >
        <Toolbar>
          {!openMenu && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={() => (setOpenMenu ? setOpenMenu(!openMenu) : {})}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, alignItems: 'center' }}
            display="flex"
          >
            {!isMobile && openMenu && (
              <img
                src={GoBack}
                height={40}
                width={40}
                style={{ marginRight: '5px' }}
                onClick={toggleDrawer}
              />
            )}
            {title}
          </Typography>

          <LanguageMenu />
          <AvatarMenu />
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { sm: openMenu ? drawerWidth : 0 },
          flexShrink: { sm: 0 },
        }}
        aria-label="menu"
      >
        <Drawer
          variant={isMobile ? 'temporary' : 'persistent'}
          open={openMenu}
          onClose={toggleDrawer}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              bgcolor: '#fff',
            },
          }}
        >
          <DrawerMenu />
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${openMenu ? drawerWidth : 0}px)` },
          mt: 8,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
